import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { GooglePieChartService } from '../services/google-pie-chart.service';
import {
    PieChartConfig,
    ColumnChartConfig
} from '../services/google-chart.config';
import { GoogleColumnChartsService } from '../services/google-column-chart.service';

declare var jquery: any;
declare var $: any;

declare var google: any;

@Component({
    selector: 'app-investors',
    templateUrl: './investors.component.html',
    styleUrls: ['./investors.component.css']
})
export class InvestorsComponent implements OnInit {
    @ViewChild('googleChartDemo', { read: ElementRef })
    googleChartDemo;

    tittle = 'WATCH LIST';
    setFullWindow = false;
    constructor(
        private router: Router,
        private _pieChartService: GooglePieChartService,
        private _columnService: GoogleColumnChartsService
    ) {
        // initialize google chart library
    }

    ngOnInit() {
        $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);

        // demo data

        // const data = new google.visualization.DataTable();
        // data.addColumn('string', 'Topping');
        // data.addColumn('number', 'Slices');
        // data.addRows([
        //   ['Mushrooms', 3],
        //   ['Onions', 1],
        //   ['Olives', 1],
        //   ['Zucchini', 1],
        //   ['Pepperoni', 2]
        // ]);

        // const data = [
        //   ['Task', 'Hours per Day'],
        //   ['Eat', 3],
        //   ['Commute', 2],
        //   ['Watch TV', 5],
        //   ['Video games', 4],
        //   ['Sleep', 10]
        // ];

        // const demoConfig1 = new PieChartConfig(
        //   'My Daily Activities at 20 years old',
        //   0.4
        // );

        // this._pieChartService.BuildPieChart(
        //   this.googleChartDemo.nativeElement,
        //   data,
        //   demoConfig1
        // );

        // TODO: the width of the cloumn bar has some problem, need fixe later
        const data = [
            ['Element', 'revenue ', { role: 'style' }, { role: 'annotation' }],
            ['FY2014', 662, '#484847', '662'],
            ['FY2014A', 936, '#484847', '936'],
            ['FY2015', 1078, '#484847', '1078'],
            ['FY2016', 1185, '#484847', '1185'],
            ['FY2017', 1306, '#C20047', '1306']
        ];
        // TODO: decrease the size of the options title
        const options: ColumnChartConfig = {
            title: 'Total revenue increased by 10.2% to $1,306M in FY2017',
            // width: '100%',
            height: 350,
            bar: { groupWidth: '95%' },
            legend: { position: 'none' }
        };

        this._columnService.BuildColumnCharet(
            this.googleChartDemo.nativeElement,
            data,
            options
        );
    }

    close() {
        // this.closeService.closeEvent(type.CATALOGUE);
        console.log('close event');
        $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
        // routerLink = '/buy'
        this.router.navigateByUrl('/myCarts');
    }
}
